import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class MenuTopSecondNotifyService {
  public changeMenuEventEmitter: Subject<
    { title: string; url: string; roles?: string[] }[]
  > = new Subject<{ title: string; url: string; roles?: string[] }[]>()

  constructor() {}

  public onChangeMenuEvent(items: { title: string; url: string; roles?: string[] }[]): void {
    this.changeMenuEventEmitter.next(items)
  }
}
